import intl from "react-intl-universal";

export const ROLE_ADMIN_VALUE = 1;
export const ROLE_TEAM_MANAGER_VALUE = 2;
export const ROLE_MATCH_ADMIN_VALUE = 3;
export const ROLE_NORMAL_VALUE = 4;

export const FIELD_NAME_ADMIN = "admin";
export const FIELD_NAME_TEAM_MANAGER = "team-manager";
export const FIELD_NAME_MATCH_ADMIN = "match-admin";
export const FIELD_NAME_NORMAL_USER = "normal-user";

export const getRoleOptions = (viewerRoles: number[]) => {
  const options = [
    {
      name: FIELD_NAME_TEAM_MANAGER,
      label: intl.get("ROLE_TEAM_MANAGER"),
      value: ROLE_TEAM_MANAGER_VALUE,
      disabled: true,
    },
    {
      name: FIELD_NAME_MATCH_ADMIN,
      label: intl.get("ROLE_MATCH_ADMIN"),
      value: ROLE_MATCH_ADMIN_VALUE,
      disabled: true,
    },
    {
      name: FIELD_NAME_NORMAL_USER,
      label: intl.get("ROLE_NORMAL"),
      value: ROLE_NORMAL_VALUE,
      disabled: true,
    },
  ];

  if (
    viewerRoles.includes(ROLE_ADMIN_VALUE) ||
    viewerRoles.includes(ROLE_TEAM_MANAGER_VALUE)
  ) {
    return options.map((option) => ({
      ...option,
      disabled: false,
    }));
  }
  return options;
};

export const isTeamManager = (roles: number[]): boolean => {
  return roles.includes(ROLE_TEAM_MANAGER_VALUE);
};
